export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const toPluralOperationsMap = (val) => {
  const pick = (obj, singular, plural) =>
    obj && obj[plural] != null ? obj[plural] : obj && obj[singular] != null ? obj[singular] : null;
  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  return days.reduce((acc, day) => {
    acc[`${day}s`] = pick(val, day, `${day}s`);
    return acc;
  }, {});
};